import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MobileService {
  public mobileMenuOpen: BehaviorSubject<boolean>;
  public loaded: boolean;

  constructor() {
    this.mobileMenuOpen = new BehaviorSubject<boolean>(false);
  }

  setOverlay(open: boolean) {
    this.loaded = true;
    this.mobileMenuOpen.next(open);
  }
}
